module.exports = __webpack_public_path__ + "img/20ne.b1f70165.svg";